<template>
<div class="chapter">
<div class="inner_page">
<a id="pFrontCover"></a><a id="pi"></a><a id="pii"></a><a id="piii"></a><a id="piv"></a>
<div class="copyright">
<p class="center ">First Mariner Books Edition 2000</p>
<p class="center spaceabove1">Afterword © 1999 by Paul Theroux</p>
<p class="center ">Copyright © 1998 by Paul Theroux</p>
<p class="center ">All rights reserved</p>
<p class="center spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="center spaceabove1"><a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a></p>
<p class="center spaceabove1">Library of Congress Cataloging-in-Publication Data is available.</p>
<p class="center spaceabove1"><span class="smallcaps">ISBN</span> 978-0-618-00199-6 (pbk)</p>
<p class="center spaceabove1">Portions of this book have appeared in <em>The New Yorker</em>.</p>
<p class="center spaceabove1">The Afterword originally appeared, in different form, in The New <em>York Times Book Review</em> and the <em>Observer</em> in 1998.</p>
<p class="center spaceabove1">Lines by Derek Walcott are from <em>Collected Poems</em> 1948–1984 by Derek Walcott. Reprinted by permission of Farrar, Straus &amp; Giroux, Inc. Lines from “The Whitsun Weddings” are from <em>Collected Poems</em> by Philip Larkin. Copyright © 1988, 1989 by the Estate of Philip Larkin. Reprinted by permission of Faber and Faber Ltd. The quotation from “Poetry of Departures” by Philip Larkin is reprinted from <em>The Less Deceived</em> by permission of Faber and Faber Ltd.</p>
<p class="center spaceabove1">eISBN 978-0-547-52619-5<br/>
v2.0421</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?32d971c7